import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

scheduleReminderModalStyles.scheduleButton = {
    css: css`
        word-break: normal;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
};
